import React, { useEffect } from 'react'
import { useLazyQuery, gql, NetworkStatus } from '@apollo/client'
import CardWidget, { Colors } from '../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../components/skeletons/CardWidgetSkeleton'
import { formatCurrency } from '../../../../utils/Helpers'
import moment from 'moment'

const GET_DATA = gql`
 query {
  revenuesAggs(
    size: 0,
    aggs: {
      total: {
        sum: {
          field: "total"
        }
      }
    }
  )
  {
    aggregations
  }
}
`

const CommissionRevenue = (): JSX.Element => {
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_DATA, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData()
  }, [])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  return (
    <CardWidget title={`Receita de comissão total (dado fixo para o ano ${moment().format('y')})`} number={formatCurrency(data.revenuesAggs.aggregations.total.value)} color={Colors.red} />
  )
}

export default CommissionRevenue
